// extracted by mini-css-extract-plugin
export var arrowUpAndDown = "FileRow-module--arrow-up-and-down--17acb";
export var file = "FileRow-module--file--4168d";
export var fileDescription = "FileRow-module--fileDescription--2f952";
export var fileDetailsContainer = "FileRow-module--fileDetailsContainer--1dd2b";
export var fileLinks = "FileRow-module--fileLinks--6a926";
export var fileSize = "FileRow-module--fileSize--5cabf";
export var fileSizeDecimal = "FileRow-module--fileSizeDecimal--dedb6";
export var fileSmall = "FileRow-module--fileSmall--dc70f";
export var fileTitle = "FileRow-module--fileTitle--40662";
export var icon = "FileRow-module--icon--0d7b6";
export var infoContainer = "FileRow-module--infoContainer--64594";